/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { CanLeave } from '@gh/common-shared';
import * as invariant from 'invariant';
import { isFunction } from 'lodash';
import { Observable } from 'rxjs';
import { ContextCanDeactivate, ContextRoute } from './context';

@Injectable()
export class LeaveContextGuard implements ContextCanDeactivate<CanLeave> {

  canDeactivate(component: CanLeave, route: ContextRoute): Observable<boolean> | Promise<boolean> | boolean {
    invariant(
      isFunction(component.canDeactivate),
      `Component for route ${route.toString()} does not have canDeactivate function`,
    );
    return component.canDeactivate();
  }
}
